import React from 'react';
import { useParams } from 'react-router-dom';

const Products = () => {
  const { category } = useParams();
  
  const allProducts = [
    { src: "images/jalistep/pic23 (59).jpg", title: "Jakobi Activated Carbon", category: "filters" }, 
    { src: "images/jalistep/pic2.jpg", title: "Ro plant industrial", category: "ro-systems" },
    { src: "images/jalistep/pic9.jpg", title: "Pleated Filters", category: "filters" },
    { src: "images/jalistep/pic4.jpg", title: "TDS Meters", category: "meters" },
    { src: "images/jalistep/pic23 (50).png", title: "Pumps", category: "pumps" },
    { src: "images/jalistep/pic14.jpg", title: "Domestic Ro with hot & cold", category: "ro-systems" },
    { src: "images/jalistep/pic7.jpg", title: "FRP Vessels", category: "vessels" },
    { src: "images/jalistep/pic23 (76).png", title: "pH Meters", category: "meters" },
    { src: "images/jalistep/pic13.jpg", title: "Dosing Pumps", category: "pumps" },
    { src: "images/jalistep/pic23 (31).jpg", title: "Ion Exchange Resin", category: "filters" },
    { src: "images/jalistep/pic23 (28).png", title: "GAC", category: "filters" },
    { src: "images/jalistep/pic23 (59).png", title: "Domestic booster pumps", category: "pumps" },
    { src: "images/jalistep/pic5.jpg", title: "Spun/PP", category: "filters" },
    { src: "images/jalistep/pic23 (44).jpg", title: "Ro pump elbow connectors", category: "accessories" },
    { src: "images/jalistep/pic23 (70).png", title: "CTO", category: "filters" },
    { src: "images/jalistep/pic23 (40).png", title: "Commercial Ro", category: "ro-systems" },
    { src: "images/jalistep/pic23 (47).png", title: "Pressure Pumps", category: "pumps" },
    { src: "images/jalistep/pic23 (64).png", title: "Ro Membrane", category: "filters" },
    { src: "images/jalistep/flow meters.png", title: "Flow Meters", category: "meters" },
    { src: "images/jalistep/Filter housing.png", title: "Filter housing", category: "accessories" },
    { src: "images/jalistep/multi port.png", title: "Multi Port Valves (MPV)", category: "accessories" },
    { src: "images/jalistep/pic14.jpg", title: "RO's", category: "ro-systems" },
    { src: "images/jalistep/pic7.jpg", title: "Vessels", category: "vessels" },
    { src: "images/jalistep/pic23 (84).png", title: "Pressure Gauge", category: "meters" }
  ];

  // Filter products by category if specified
  const filteredProducts = category 
    ? allProducts.filter(product => product.category === category)
    : allProducts;

  // Get category title
  const categoryTitles = {
    "filters": "Water Filters",
    "pumps": "Water Pumps",
    "ro-systems": "RO Systems",
    "meters": "Meters & Gauges",
    "vessels": "Vessels & Tanks",
    "accessories": "Accessories"
  };

  return (
    <div className="container py-4">
      <h2 className="mb-4">
        {category ? categoryTitles[category] : "Our Products"}
      </h2>
      <hr />
      
      <div className="row">
        {filteredProducts.map((product, index) => (
          <div key={index} className="col-lg-3 col-md-4 col-sm-6 mb-4">
            <div className="card product-card shadow h-100">
              <img 
                src={product.src} 
                alt={product.title} 
                className="card-img-top product-img"
                style={{ height: "200px", objectFit: "cover" }}
              />
              <div className="card-body">
                <h5 className="card-title text-dark">{product.title}</h5>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Products;